export default __webpack_public_path__ + "static/media/housefire.bde2b85c.svg";